import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _class, _class2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import Collapse from '@mui/material/Collapse';
import { injectIntl, defineMessages } from 'react-intl';
import isLoggedIn from '../../helpers/checkAuth';
import RestrictedAccessModal from '../RestrictedAccessModal/RestrictedAccessModal';
import Link from '../Link';
import SkholeIcon22 from '../statelessComponents/Icons/SkholeIcon22';
import SkholeIconOpenBook from '../statelessComponents/Icons/SkholeIconOpenBook';
import s from './LessonsListItem.scss';
import CoursePodcastItem from '../../routes/courseDetails/CoursePodcastItem/CoursePodcastItem';
import * as lessonDetailsActions from '../../actions/lessonDetails';
import * as podcastLessonActions from '../../actions/podcastLesson';
import { isUserFromWhitelabeledOrganization, userSkillEvaluationEnabled } from '../../helpers';
import intlPropTypes from '../../constants/intlPropTypes';
var messages = defineMessages({
  finishLessonTitle: {
    id: "LessonListItem.finishTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Finished lesson"
    }]
  },
  notStartedLessonTitle: {
    id: "LessonListItem.notStartedTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Not started lesson"
    }]
  },
  podcastAudioIsBeingTranscodedTitle: {
    id: "LessonListItem.podcastAudioIsBeingTranscodedTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Audio is being transcoded"
    }]
  }
});
var LessonsListItem = (_dec = withStyles(s), _dec2 = connect(function (state) {
  return {
    auth: state.auth,
    lang: state.intl.locale,
    offline: state.online.offline,
    courseWasReset: state.courseDetails.courseWasReset,
    isLessonLoading: state.lessonDetails.loading,
    lesson: state.lessonDetails.lesson,
    openedPodcastLesson: state.podcastLesson.openedPodcastLesson,
    isPodcastLessonLoading: state.podcastLesson.isPodcastLessonLoading,
    shouldScrollIntoView: state.podcastLesson.shouldScrollIntoView,
    transcodingJobs: state.transcodingJobs.jobs
  };
}, function (dispatch) {
  return bindActionCreators({
    getLessonBySlug: lessonDetailsActions.getLessonBySlug,
    resetLesson: lessonDetailsActions.reset,
    setOpenedPodcastLesson: podcastLessonActions.setOpenedPodcastLesson,
    setIsLoadingPodcastLesson: podcastLessonActions.setIsLoading,
    setNextPodcastLesson: podcastLessonActions.setNextLesson
  }, dispatch);
}), injectIntl(_class = _dec(_class = _dec2(_class = (_class2 = /*#__PURE__*/function (_Component) {
  _inherits(LessonsListItem, _Component);
  var _super = _createSuper(LessonsListItem);
  function LessonsListItem() {
    var _this;
    _classCallCheck(this, LessonsListItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isRestrictedAccessModalOpened: false
    });
    _defineProperty(_assertThisInitialized(_this), "onClickListItem", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        var _this$props, _this$props$course, type, courseId, item, getLessonBySlug, setOpenedPodcastLesson, resetLesson, openedPodcastLesson, setIsLoadingPodcastLesson, setNextPodcastLesson, isUserHasAccess, itemToOpen;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, _this$props$course = _this$props.course, type = _this$props$course.type, courseId = _this$props$course._id, item = _this$props.item, getLessonBySlug = _this$props.getLessonBySlug, setOpenedPodcastLesson = _this$props.setOpenedPodcastLesson, resetLesson = _this$props.resetLesson, openedPodcastLesson = _this$props.openedPodcastLesson, setIsLoadingPodcastLesson = _this$props.setIsLoadingPodcastLesson, setNextPodcastLesson = _this$props.setNextPodcastLesson;
              isUserHasAccess = _this.checkAuth(event);
              if (isUserHasAccess) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              if (!(type === 'podcast')) {
                _context.next = 18;
                break;
              }
              itemToOpen = item._id;
              setNextPodcastLesson({});
              if (!(itemToOpen === openedPodcastLesson)) {
                _context.next = 12;
                break;
              }
              setOpenedPodcastLesson(null);
              resetLesson();
              _context.next = 18;
              break;
            case 12:
              setIsLoadingPodcastLesson(true);
              resetLesson();
              setOpenedPodcastLesson(itemToOpen, true);
              _context.next = 17;
              return getLessonBySlug(item.slug, {
                courseId: courseId
              });
            case 17:
              setIsLoadingPodcastLesson(false);
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "goToNextLesson", function () {
      var _this$props2 = _this.props,
        lesson = _this$props2.lesson,
        goToNextPodcastLesson = _this$props2.goToNextPodcastLesson;
      goToNextPodcastLesson(lesson);
    });
    _defineProperty(_assertThisInitialized(_this), "checkAuth", function (event) {
      if (_this.hasAccess()) {
        return true;
      }
      event.preventDefault();
      event.stopPropagation();
      _this.setState({
        isRestrictedAccessModalOpened: true
      });
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "closeRestrictedAccessModal", function () {
      _this.setState({
        isRestrictedAccessModalOpened: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "hasAccess", function () {
      var _this$props3 = _this.props,
        auth = _this$props3.auth,
        course = _this$props3.course,
        item = _this$props3.item;
      return item.isGloballyFree || isLoggedIn(auth) && course.isAvailable;
    });
    _defineProperty(_assertThisInitialized(_this), "scrollToLessonListItemStart", function () {
      if (_this.props.shouldScrollIntoView) {
        _this.lessonRef.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
    return _this;
  }
  _createClass(LessonsListItem, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        item = _this$props4.item,
        auth = _this$props4.auth,
        offline = _this$props4.offline,
        course = _this$props4.course,
        active = _this$props4.active,
        formatMessage = _this$props4.intl.formatMessage,
        isCompleted = _this$props4.isCompleted,
        courseWasReset = _this$props4.courseWasReset,
        showPodcastContent = _this$props4.showPodcastContent,
        isPodcastLessonLoading = _this$props4.isPodcastLessonLoading,
        isLessonLoading = _this$props4.isLessonLoading,
        cancelGoToNextSectionItem = _this$props4.cancelGoToNextSectionItem,
        disabled = _this$props4.disabled,
        transcodingJobs = _this$props4.transcodingJobs;
      var isRestrictedAccessModalOpened = this.state.isRestrictedAccessModalOpened;
      var isPodcast = course.type === 'podcast';
      var showListItem = !this.hasAccess() || !isPodcast || isPodcast && course.totalLessons !== 1;
      var completedSectionItemsNumber = course.completedLessons + course.completedQuizzes;
      var isWhitelabeled = isUserFromWhitelabeledOrganization(auth);
      var isUserSkillEvaluationEnabled = userSkillEvaluationEnabled(auth);
      var showEvaluationModal = (!isWhitelabeled || isUserSkillEvaluationEnabled) && !_.get(course, 'isUserSkillEvaluated') && !course.progress && !completedSectionItemsNumber && !offline && !isPodcast && isLoggedIn(auth);
      var itemTime = function itemTime(timeForItem) {
        if (timeForItem.time > 3600) {
          var duration = moment.duration(timeForItem.time, 'seconds');
          return "".concat(duration.hours().toString().padStart(2, '0'), ":").concat(duration.minutes().toString().padStart(2, '0'), ":").concat(duration.seconds().toString().padStart(2, '0'));
        }
        return moment(1000 * timeForItem.time).format('mm:ss');
      };
      var isTextLesson = !_.get(item, 'audios.length') && !_.get(item, 'videos.length') && !item.youtubeVideoUrl;
      var isPodcastLessonTranscoding = false;
      if (isPodcast && _.get(item, '_id') && (transcodingJobs === null || transcodingJobs === void 0 ? void 0 : transcodingJobs.length) > 0 && transcodingJobs.find(function (job) {
        return item._id === job.lessonId && job.type === 'audio';
      })) {
        isPodcastLessonTranscoding = true;
      }
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(_ref2) {
          _this2.lessonRef = _ref2;
        }
      }, showListItem && /*#__PURE__*/_jsx(ListItem, {
        "data-test-id": "gnlQewAF7FIYatGN7RhxS",
        className: classNames(s.lessonListItem, _defineProperty({}, s.active, active)),
        component: this.hasAccess() && !isPodcast ? Link : 'div',
        to: "/courses/".concat(course.slug, "/lessons/").concat(item.slug).concat(showEvaluationModal ? '?showEvaluationModal' : ''),
        onClick: this.onClickListItem,
        button: true,
        disabled: isPodcastLessonLoading || disabled
      }, void 0, !isPodcast && /*#__PURE__*/_jsx(ListItemIcon, {
        classes: {
          root: s.lessonListItemIconRoot
        }
      }, void 0, isTextLesson ? /*#__PURE__*/_jsx(SkholeIconOpenBook, {
        className: s.playLessonIcon,
        color: active ? '#fff' : 'primary'
      }) : /*#__PURE__*/_jsx(SkholeIcon22, {
        className: s.playLessonIcon,
        color: active ? '#fff' : 'primary'
      })), isLoggedIn(auth) && /*#__PURE__*/_jsx(ListItemText, {
        primary: item.name,
        secondary: "".concat(isPodcastLessonTranscoding ? formatMessage(messages.podcastAudioIsBeingTranscodedTitle) : '', " ").concat(!isPodcastLessonTranscoding && item.time ? itemTime(item) : ''),
        classes: {
          root: s.lessonTitleTextWrapper,
          primary: s.lessonTitleTextPrimary,
          secondary: s.lessonTitleTextSecondary
        }
      }), !isLoggedIn(auth) && /*#__PURE__*/_jsx(ListItemText, {
        primary: item.name,
        secondary: item.time ? itemTime(item) : '',
        classes: {
          root: s.lessonTitleTextWrapper,
          primary: s.lessonTitleTextPrimary,
          secondary: s.lessonTitleTextUnAuthSecondary
        }
      }), /*#__PURE__*/_jsx(ListItemSecondaryAction, {
        className: s.secondaryAction
      }, void 0, isCompleted && isLoggedIn(auth) && /*#__PURE__*/_jsx(Tooltip, {
        id: "tooltip-finished",
        title: formatMessage(messages.finishLessonTitle)
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.completedIcon
      })), isCompleted === false && isLoggedIn(auth) && /*#__PURE__*/_jsx(Tooltip, {
        id: "tooltip-not-started",
        title: formatMessage(messages.notStartedLessonTitle)
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.notCompletedIcon
      })))), (isPodcastLessonLoading || isLessonLoading) && showPodcastContent && /*#__PURE__*/_jsx(CircularProgress, {
        size: 40,
        className: s.lessonLoadingSpinner
      }), isPodcast && /*#__PURE__*/_jsx(Collapse, {
        mountOnEnter: true,
        unmountOnExit: true,
        onEntered: this.scrollToLessonListItemStart,
        "in": showPodcastContent && this.hasAccess() && !isPodcastLessonLoading && !isLessonLoading
      }, void 0, /*#__PURE__*/_jsx(CoursePodcastItem, {
        isCompleted: isCompleted,
        lessonItem: item,
        goToNextLesson: this.goToNextLesson,
        cancelGoToNextLesson: cancelGoToNextSectionItem
      }, "".concat(_.get(item, '_id'), "_podcastItem_").concat(courseWasReset))), /*#__PURE__*/_jsx(Modal, {
        open: isRestrictedAccessModalOpened,
        onClose: this.closeRestrictedAccessModal
      }, void 0, /*#__PURE__*/_jsx(RestrictedAccessModal, {
        onClose: this.closeRestrictedAccessModal
      })));
    }
  }]);
  return LessonsListItem;
}(Component), _defineProperty(_class2, "defaultProps", {
  active: false,
  isCompleted: undefined,
  openedPodcastLesson: '',
  goToNextPodcastLesson: _.noop,
  cancelGoToNextSectionItem: _.noop,
  offline: false,
  disabled: false
}), _class2)) || _class) || _class) || _class);
export { LessonsListItem as default };